export default __webpack_public_path__ + "static/media/kettle.219d76d6.svg";